import { useData } from "./DataContext.js";

export default function TitlePage (props)
{
    const gData = useData();

    const bgImageSrc = gData.gameId + "/pictures/title-light.jpg";
    const fgImageSrc = gData.gameId + "/pictures/title-chars.png";

    return (
	<>
	    <div className="vw-100 vh-100 opacity-50" style={{ backgroundImage: "url(" + bgImageSrc + ")", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "50% 50%" }}/>
	    <img className="position-absolute" src={fgImageSrc} alt="Personnages principaux" style={{ width: "50%", left: "55%", top: "5%" }}/>
	    
	    <div className="position-absolute text-center vh-100" style={{ top: "10%", left: "10%", width: "40%" }}>
		<h1 className="text-white user-select-none" style={{ fontSize: "50px", textShadow: "#AAF 1px 1px 10px" }}>Qui veut les données<br/>d'Irène Hooper&nbsp;?</h1>
		<h2 className="text-white user-select-none" style={{ fontSize: "20px" }}>Un jeu d'enquête numérique sur la cybersécurité</h2>
		{props.children}
	    </div>
	</>
    );
}
